import { apiClient } from '../../lib/api-client';
import { PATIENT_UHID_SEARCH_LIMIT } from '../../lib/patient-uhid-search';
import type {
  CreateInvestigationBillPayload,
  InvestigationBill,
  InvestigationBillListFilters,
  InvestigationBillLookupOption,
  InvestigationPayment,
  Pagination,
  UpdateInvestigationBillPayload,
} from './types';

interface ApiResponse<T> { success: true; data: T }
interface PaginatedResponse<T> extends ApiResponse<T[]> { pagination: Pagination }

const compactParams = (params: object) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== '' && value !== undefined && value !== null),
);

export const fetchInvestigationBills = async (filters: InvestigationBillListFilters) => {
  const response = await apiClient.get<PaginatedResponse<InvestigationBill>>('/investigation-bill/bills', { params: compactParams(filters) });
  return response.data;
};

export const fetchInvestigationBill = async (id: string) => {
  const response = await apiClient.get<ApiResponse<InvestigationBill>>(`/investigation-bill/bills/${id}`);
  return response.data.data;
};

export const createInvestigationBill = async (payload: CreateInvestigationBillPayload) => {
  const response = await apiClient.post<ApiResponse<InvestigationBill>>('/investigation-bill/bills', payload);
  return response.data.data;
};

export const updateInvestigationBill = async (id: string, payload: UpdateInvestigationBillPayload) => {
  const response = await apiClient.patch<ApiResponse<InvestigationBill>>(`/investigation-bill/bills/${id}`, payload);
  return response.data.data;
};

export const updateInvestigationBillPayment = async (id: string, paymentIndex: number, payload: { mode: InvestigationPayment['mode']; bankName: string | null; amount: number }) => {
  const response = await apiClient.patch<ApiResponse<InvestigationBill>>(`/investigation-bill/bills/${id}/payments/${paymentIndex}`, payload);
  return response.data.data;
};

export const fetchInvestigationBillLookups = async (type: string, search = '', departmentId = '', state = '') => {
  const response = await apiClient.get<ApiResponse<InvestigationBillLookupOption[]>>('/investigation-bill/lookups', { params: compactParams({ type, search, departmentId, state, limit: type === 'patients' ? PATIENT_UHID_SEARCH_LIMIT : 500 }) });
  return response.data.data;
};
